import { render, staticRenderFns } from "./Jobshistory.vue?vue&type=template&id=55ce409c"
import script from "./Jobshistory.vue?vue&type=script&lang=js"
export * from "./Jobshistory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports